import { EntityPropList } from '@/common/entities/entityProp/EntityPropList';
import { IncDataSrcList } from '@/common/entities/incDataSrc/IncDataSrcList';
import { EntityDetail } from '@/common/entityFramework/entityDetail/EntityDetail';
import { EntityTabs } from '@/common/entityFramework/entityTabs/EntityTabs';
import { useEntityMgr } from '@/common/entityFramework/entityView/EntityMgrContext';
import { useRsrc } from '@/common/rsrc/RsrcContext';
import { ValList } from '@/common/val/ValList';
import { useCtrtOutline } from '@/md/entities/ctrt/useCtrtOutline';
import { ProgProdTierList } from '@/md/entities/ProgProdTierList';
import { useEffect, useState } from 'react';
import { ProgContextStrip } from '../prog/ProgContextStrip';
import { ProgProdForm } from './ProgProdForm';

export const ProgProdDetail = () => {
  const { entityObj } = useEntityMgr();
  const rsrc = useRsrc();
  const [progObj, setProgObj] = useState(null);

  useEffect(() => {
    let current = true;
    setProgObj(null);

    if (!entityObj?.progId) return;
    rsrc.byId('md', 'PROG', entityObj.progId).then((prog) => {
      if (current) setProgObj(prog);
    });

    return () => {
      current = false;
    };
  }, [entityObj?.progId]);

  const { augButtons, outlineContent } = useCtrtOutline({
    ctrtId: entityObj.ctrtId,
    entity: 'PROG_PROD',
    entityId: entityObj.id,
  });

  const tabSpecs = [
    { id: 'infoTab', label: 'Info', content: <ProgProdForm /> },
    { id: 'tierTab', label: 'Tier', content: <ProgProdTierList parentEntityObj={entityObj} /> },
    {
      id: 'entityProps',
      label: 'Properties',
      content: <EntityPropList parentEntity="PROG_PROD" parentEntityObj={entityObj} />,
    },
    { id: 'val', label: 'Validations', content: <ValList parentEntity="PROG_PROD" parentEntityId={entityObj.id} /> },
    {
      id: 'incDataSrcs',
      label: 'Inclusion Data Source',
      content: <IncDataSrcList progProdId={entityObj.id} />,
    },
  ];

  return (
    <EntityDetail tabSpecs={tabSpecs} augButtons={augButtons}>
      {outlineContent ?? (
        <>
          <ProgContextStrip ctrtId={entityObj.ctrtId} progObj={progObj} />
          <EntityTabs tabSpecs={tabSpecs} />
        </>
      )}
    </EntityDetail>
  );
};
